import { useMemo } from "react";

import useProductCategories from "hooks/use-product-categories.hook";

// Archived categories are not offered, but a product already carrying one keeps
// it as its current value.
export default function useCategoryOptions(
  savedCategoryId?: number | "" | null
) {
  const { isEnabled, activeCategories, getCategory } = useProductCategories();
  const savedCategory = getCategory(savedCategoryId || null);

  const options = useMemo(
    () => [
      ...activeCategories.map((category) => ({
        value: category.id,
        label: category.name
      })),
      ...(savedCategory?.is_archived
        ? [
            {
              value: savedCategory.id,
              label: `${savedCategory.name} (Archived)`
            }
          ]
        : [])
    ],
    [activeCategories, savedCategory]
  );

  return { showCategory: isEnabled && options.length > 0, options };
}
